import FullscreenConfirm from "@pathwright/ui/src/components/confirm/FullscreenConfirm"
import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import { ConnectStores } from "lib/core/store"
import { withPrintContent } from "lib/core/utils/print"
import capitalize from "lodash/capitalize"
import flowRight from "lodash/flowRight"
import get from "lodash/get"
import React from "react"
import GroupStepSlider from "./GroupStepSlider"
import "./styles/StepSequence.css"

class StepSequence extends React.Component {
  static displayName = "StepSequence"

  state = {
    itemCleared: null
  }

  shouldComponentUpdate(nextProps) {
    // Only re-render if the sequence group has changed
    let shouldUpdate =
      get(this.props.group, "id") !== get(nextProps.group, "id")

    // change in number of items, likely after a sync where an item was added or removed
    if (
      this.props.group &&
      nextProps.group &&
      this.props.group.items.length !== nextProps.group.items.length
    ) {
      shouldUpdate = true
    }

    return shouldUpdate
  }

  componentWillUnmount() {
    // HACK ALERT: Clearing the step (and also the lesson) at this point actually
    // takes place after the lesson has already been selected in the case where the
    // user is navigating from a step to the parent lesson. In which case the lesson is
    // cleared by the route remains on the lesson and the user merely sees the path.
    // Only clearing step/lesson if not navigating to a lesson.
    if (window.location.pathname.indexOf("/lesson/") === -1) {
      this.props.clearSelectedStep()
      this.props.clearStep(true) // don't preserve group
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let clearedPathItem = null

    try {
      if (
        this.props.group &&
        !nextProps.group &&
        !this.props.findItem(this.props.group.sync_source_id)
      ) {
        clearedPathItem = this.props.group
      } else if (
        this.props.step &&
        !nextProps.step &&
        !this.props.findItem(this.props.step.sync_source_id)
      ) {
        clearedPathItem = this.props.step
      }
    } catch (error) {
      // likely could not find the item as a result of the path store being cleared after auth change - noop
    }

    if (clearedPathItem) {
      this.setState({
        itemCleared: {
          name: clearedPathItem.name,
          type: clearedPathItem.item_type
        }
      })
    }
  }

  renderItemClearedConfirmation() {
    const itemTypeMap = {
      A: "step",
      G: "lesson"
    }

    const itemTypeName = capitalize(itemTypeMap[this.state.itemCleared.type])

    return (
      <FullscreenConfirm
        heading={`The ${itemTypeName} "${this.state.itemCleared.name}" no longer exists.`}
        confirmPrompt="Ok"
        onConfirm={() =>
          window.App.navigate(window.App.getStore("path").computeURLForState())
        }
        hideCancel
      />
    )
  }

  render() {
    return (
      <div className="StepSequence">
        {this.state.itemCleared ? (
          this.renderItemClearedConfirmation()
        ) : this.props.isLoading ? (
          <LoadingCircle inverted />
        ) : this.props.step ? (
          <GroupStepSlider />
        ) : null}
      </div>
    )
  }
}

const mapStateToProps = function (state, ownProps) {
  const { step, group } = state.stepStore.state
  const { clearStep } = state.stepStore.action
  const { mode, selected_step } = state.pathStore.state
  const { clearSelectedStep } = state.pathStore.action
  const { findItem } = state.pathStore.request
  const isLoading = !(step && step.id) && !!selected_step
  return _.assign(
    {},
    {
      isLoading,
      step,
      group,
      mode,
      clearStep,
      clearSelectedStep,
      findItem
    },
    ownProps
  )
}

const stores = [
  { store: "step", watch: ["group"] },
  { store: "path", watch: ["mode", "selected_step"] }
]

const StepSequenceContainer = flowRight(
  withPrintContent(".Step--is-active .Step__ContentWrap")
)(ConnectStores(StepSequence, stores, {}, mapStateToProps))

StepSequenceContainer.displayName = "StepSequenceContainer"

export default StepSequenceContainer
